import { FC, useCallback, useMemo } from "react";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { infrastructureArchitecturePossibleServicesWithLabelsSelector } from "@/store/infrastructure-architecture/selectors/infrastructureArchitecturePossibleServicesWithLabelsSelector";
import { infrastructureArchitectureSelectedServicesSelector } from "@/store/infrastructure-architecture/selectors/infrastructureArchitectureSelectedServicesSelector";
import { DropdownSelectOption } from "@/components/common/select/dropdown-select/utils/types/types";
import { setInfrastructureArchitectureRequestData } from "@/store/infrastructure-architecture/infrastructureArchitectureSlice";
import { SolutionArchitectResourceType } from "@/services/cloudchipr.api";
import { DropdownSelect } from "@/components/common/select/dropdown-select/DropdownSelect";
import { infrastructureArchitectureRegionFilterFn } from "@/components/pages/infrastructure-architecture/utils/helpers/infrastructureArchitectureRegionFilterFn";
import { InfrastructureArchitectureSelectTriggerComponent } from "@/components/pages/infrastructure-architecture/components/select-panel/body/common/InfrastructureArchitectureSelectTriggerComponent";

export const InfrastructureArchitectureServiceSelect: FC = () => {
  const dispatch = useAppDispatch();
  const selectedServices = useAppSelector(
    infrastructureArchitectureSelectedServicesSelector,
  );
  const services = useAppSelector(
    infrastructureArchitecturePossibleServicesWithLabelsSelector,
  );

  const renderOptions: DropdownSelectOption[] = useMemo(() => {
    return (
      services?.map((option) => ({
        value: option.value,
        listItemHeight: 51,
        rawValue: option,
        label: option.title,
      })) ?? []
    );
  }, [services]);

  const changeHandler = useCallback(
    (values: string[]) => {
      dispatch(
        setInfrastructureArchitectureRequestData({
          selectedServices: values?.length
            ? (values as SolutionArchitectResourceType[])
            : undefined,
        }),
      );
    },
    [dispatch],
  );

  return (
    <DropdownSelect
      disabled={!services?.length}
      label="Select Service/s"
      options={renderOptions}
      wrapperVariant="dropdown"
      submitHandlerOnClose={changeHandler}
      values={selectedServices ?? []}
      filterFn={infrastructureArchitectureRegionFilterFn}
      TriggerComponent={InfrastructureArchitectureSelectTriggerComponent}
    />
  );
};
